import AggregationType from "./aggregation-type";
var count;
count = function (field, filter) {
    return {
        type: AggregationType.count,
        field: field,
        filter: filter,
    };
};
export default count;
